import React from "react";
import posthog from "posthog-js";

const DUMMY_DATA = {
   driverVerification: {
      driverFirstName: "John",
      driverLastName: "Doe",
      driverEmail: "john.doe@example.com",
      driverPhone: "+15106852233",
      locationMessage: "Location verified! (Lat: 40.7128, Lng: -74.0060)",
      isEmpty: "No",
      emptyTime: "2:30 PM",
      emptyLocation: "New York, NY",
      smsConsent: true,
      consent: true,
   },
   dispatch: {
      dispatcherFirstName: "Jane",
      dispatcherLastName: "Smith",
      dispatcherEmail: "jane.smith@dispatch.com",
      afterHoursPhone: "+15109876543",
      usDotNumber: "1234567",
      mcNumber: "987654",
      driverFirstName: "Mike",
      driverLastName: "Johnson",
      driverPhoneNumber: "+15106852233",
      driverType: "Solo",
      driverConsent: "Yes",
      equipmentType: "Dry Van",
      truckNumber: "T-001",
      trailerNumber: "TR-502",
      truckVin: "1HGBH41JXMN109186",
      truckLicense: "ABC123",
      truckLicenseState: "New York",
      driverLocation: "Los Angeles, CA",
      isDriverEmpty: "No",
      emptyTime: "3:00 PM EST",
      emptyLocation: "Chicago, IL",
      enableAdditionalDrivers: false,
   },
};

const environment = process.env.REACT_APP_ENVIRONMENT || "dev";

const DummyDataButton = ({ formType, onFillData, className = "" }) => {
   const isProduction = environment.toLowerCase() === "prod";

   // Don't render the button in production
   if (isProduction) {
      return null;
   }

   const handleFillDummyData = () => {
      const dummyData = DUMMY_DATA[formType];
      if (dummyData) {
         onFillData(dummyData);
      }
   };

   return (
      <button
         type="button"
         onClick={handleFillDummyData}
         className={`dummy-data-button ${className}`}
         title="Fill form with dummy data (development only)"
      >
         <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            style={{ marginRight: "8px" }}
         >
            <path
               strokeLinecap="round"
               strokeLinejoin="round"
               strokeWidth="2"
               d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4"
            />
         </svg>
         Fill Dummy Data
      </button>
   );
};

export default DummyDataButton;
